import axios from '@/axios.js'

const state = () => ({
    syaratbayars: []
})

const mutations = {
    SET_SYARATBAYARS (state, payload) {
      state.syaratbayars = payload
    },
    ADD_SYARATBAYAR (state, item) {
      state.syaratbayars.unshift(item)
    },
    UPDATE_SYARATBAYAR (state, syaratbayar) {
      const syaratbayarIndex = state.syaratbayars.findIndex((p) => p.id === syaratbayar.id)
      Object.assign(state.syaratbayars[syaratbayarIndex], syaratbayar)
    },
    REMOVE_SYARATBAYAR (state, itemId) {
      const ItemIndex = state.syaratbayars.findIndex((p) => p.id === itemId)
      state.syaratbayars.splice(ItemIndex, 1)
    },
}

const actions = {
  fetchSyaratBayar ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/term-list/syaratbayar`)
        .then((response) => {
          commit('SET_SYARATBAYARS', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  addSyaratBayar ({ commit }, syaratbayar ) {
    return new Promise((resolve, reject) => {
      axios.post('/term-add', syaratbayar)
        .then((response) => {
          commit('ADD_SYARATBAYAR', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateSyaratBayar ({ commit }, syaratbayar) {
    return new Promise((resolve, reject) => {
      axios.post(`/term-update/${syaratbayar.id}`, syaratbayar)
        .then((response) => {
            commit('UPDATE_SYARATBAYAR', response.data.data)
            resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeSyaratBayar ({ commit }, syaratbayar) {
    return new Promise((resolve, reject) => {
      axios.delete(`/term-delete/${syaratbayar.id}`)
        .then((response) => {
            commit('REMOVE_SYARATBAYAR', syaratbayar.id)
            resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  }
}

export default {
  isRegistered: false,
  namespaced: true,
  state,
  actions,
  mutations
}